import { render, staticRenderFns } from "./SecondCrumb.vue?vue&type=template&id=6f468a22&scoped=true"
import script from "./SecondCrumb.vue?vue&type=script&lang=js"
export * from "./SecondCrumb.vue?vue&type=script&lang=js"
import style0 from "./SecondCrumb.vue?vue&type=style&index=0&id=6f468a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f468a22",
  null
  
)

export default component.exports